import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Menu } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IconDisplay from '../subcomponents/IconDisplay';
import NavMenuItem from '../subcomponents/NavMenuItem';

export default function NavMenuMobile({
    navigationItems,
    handlePathDirection
}) {
    const navigate = useNavigate();

    const [anchorElNav, setAnchorElNav] = useState(null);

    const handleOpenNavMenu = (e) => {
        setAnchorElNav(e.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton size="large" onClick={handleOpenNavMenu}>
                <MenuIcon fontSize="large" sx={{ color: 'white.main' }} />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: 'block', md: 'none' } }}
            >
                {navigationItems.map((item, index) => (
                    <NavMenuItem
                        key={index}
                        icon={<IconDisplay component={item} style={{ color: 'secondary.main' }} />}
                        clickFn={() => {
                            handleCloseNavMenu();
                            navigate(handlePathDirection(item));
                        }}
                        text={item}
                        textStyle={{ color: 'secondary.light' }}
                    />
                ))}
            </Menu>
        </Box>
    );
}